import { useEffect, useRef } from "react";

const W = 1440;
const H = 480;
const LINES = 16;
const K = (2 * Math.PI) / W;

function center(x, s) {
  return (
    H / 2 +
    85 * Math.sin(K * x + 0.9 * Math.sin(0.32 * s)) +
    30 * Math.sin(2 * K * x + 1.1 + 0.45 * s) +
    20 * Math.sin(1.5 * K * x + 2 - 0.38 * s)
  );
}

function spread(x, s) {
  return 62 + 22 * Math.sin(1.3 * K * x + 0.9 + 0.5 * s) + 12 * Math.sin(2.7 * K * x - 0.35 * s);
}

function linePath(t, i, s) {
  let d = "";
  for (let x = -20; x <= W + 20; x += 16) {
    const y = center(x, s) + 2 * t * spread(x, s) + 6 * t * Math.sin(2 * K * x + 2.3 + 0.6 * s + i * 0.15);
    d += `${d ? " L" : "M"}${x},${y.toFixed(1)}`;
  }
  return d;
}

const LINE_T = Array.from({ length: LINES }, (_, i) => i / (LINES - 1) - 0.5);

export function LoginWaves({ color = "#ffffff" }) {
  const refs = useRef([]);

  useEffect(() => {
    const draw = (s) => {
      LINE_T.forEach((t, i) => refs.current[i]?.setAttribute("d", linePath(t, i, s)));
    };
    // Con "Riduci movimento" attivo sul dispositivo le onde si muovono comunque, a metà velocità.
    const speed = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0.5 : 1;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      draw(((now - start) / 1000) * speed);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="login-waves">
      <div className="absolute left-0 w-full" style={{ top: "16%", height: "68%" }}>
        <svg className="login-wave h-full w-full" viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
          <g fill="none" stroke={color} strokeWidth="1.1" strokeLinecap="round">
            {LINE_T.map((t, i) => (
              <path
                key={i}
                ref={(el) => (refs.current[i] = el)}
                d={linePath(t, i, 0)}
                opacity={(0.35 + 0.55 * (1 - Math.abs(t) * 2)) * 0.6}
                vectorEffect="non-scaling-stroke"
              />
            ))}
          </g>
        </svg>
      </div>
    </div>
  );
}
